<template>
  <div>
    <div v-if="!digitalContents.total">
      <h3>Nenhum(a) {{ content_type == 'digital-contents' ? 'conteúdo digital' : 'vídeo aula' }} encontrado(a) para este módulo :c</h3>
    </div>
    <vs-row vs-w="12" v-if="digitalContents.total" vs-align="flex-start">
      <vs-col class="mb-3" v-for="(item) in digitalContents.data" :key="item.id" vs-type="flex" vs-justify="center" vs-align="top" vs-lg="4" vs-sm="6" vs-xs="12" >
        <vs-card @click.native="goToContent(item.id)" class="cardx" actionable>
          <div slot="header">
            <h4>
              {{ item.titulo }}
            </h4>
          </div>
          <div slot="media">
            <img :src="item.capa">
          </div>
          <div>
            <span v-html="item.descricao"></span>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-pagination :total="digitalContents.lastPage" v-model="currentPage"></vs-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import digitalContentService from "../../_services/digitalContent.service.js";

export default {
  data() {
    return {
      digitalContents: [],
      currentPage: 1
    };
  },
  props: {
    content_type: {
      type: String,
      default: 'digital-contents'
    }
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  watch: {
    currentPage: function (newValue) {
      this.fetchDigitalContents(newValue)
    }
  },
  methods: {
    goToContent(itemId) {
      this.$router.push(`/${this.content_type}/${itemId}`)
    },
    async fetchDigitalContents(page) {
      this.digitalContents = await digitalContentService.getDigitalContents(
        this.account.user.student.id,
        this.$route.query.module_id,
        page ? page : 1,
        this.content_type
      );
      this.currentPage = this.digitalContents.page
    }
  },
  created() {
    this.fetchDigitalContents();
  }
};
</script>
